/**
  * 横向堆叠柱状图
  * @param unit 单位
  * @param yData []y轴数据
  * @param dataArr [{name:'',data:[]}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    color: [
      "#28CCCB",
      "#59A3F3",
      "#94B794",
      "#AE9AF3",
      "#819CEC",
      "#D2BB85",
      "#DEE0E0",
    ],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    legend: {
      type: "scroll",
      bottom: "bottom",
      itemHeight: 5,
      itemWidth: 5,
    },
    grid: {
      left: "3%",
      right: "1%",
      top: "20px",
      bottom: "25px",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      splitLine: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      inverse: true,
      splitLine: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: "#8C8C8C",
        fontSize: 14,
      },
      data: paramObj.yData,
    },
    series: [],
  };
  paramObj.dataArr.forEach((v, i) => {
    option.series.push({
      name: v.name,
      type: "bar",
      stack: "total",
      barMaxWidth: 16,
      emphasis: {
        focus: "series",
      },
      data: v.data,
    });
  });

  return option
  
}